import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import http from '../services/httpService';
import useIsMounted from './useIsMounted';

export default function useAllBlogs() {
	const [blogs, setBlogs] = useState(null);
	const { pathname } = useLocation();
	const isMounted = useIsMounted();

	useEffect(() => {
		const allowed = ['/blogs'];

		async function getBlogs() {
			try {
				if (
					!http.getCurrentUser() ||
					blogs ||
					!allowed.includes(pathname)
				)
					return;
				const { data } = await http.getAllBlogs();
				if (isMounted()) setBlogs(data);
			} catch (error) {
				console.log('error :>> ', error);
			}
		}
		getBlogs();
	}, [isMounted, blogs, pathname]);
	return [blogs, setBlogs];
}
